import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FontsService } from '../../../services/fonts/fonts.service';
import { NotyService } from '../../../services/common/noty.service';
import { FileUploader } from 'ng2-file-upload';
import { NumberValidatorDirective } from 'src/app/directives/number-validator.directive';

@Component({
  selector: 'app-font-index',
  templateUrl: './font-index.component.html',
  styleUrls: ['./font-index.component.scss'],
})
export class FontIndexComponent implements OnInit {
  constructor(private fontsService: FontsService, private route: ActivatedRoute, private router: Router, private notyService: NotyService) {}

  searchTerm: String = '';
  fonts: Array<any> = [];
  fontsMaxCount: number;
  fontFormInput: String = '';
  isCreating: Boolean = false;
  isDeleting: Boolean = false;
  formSubmitting: Boolean = false;
  formSubmitted: Boolean = false;
  paginateParams: any = {
    page: 1,
    per_page: 5,
  };
  fontData: Object = {};
  fontName: String = '';
  fontDescription: String = '';
  isFontDefault: Boolean = false;
  uploader: FileUploader;
  boldUploader: FileUploader;
  italicUploader: FileUploader;
  boldItalicUploader: FileUploader;
  uploadURL: string = 'fonts.json';
  resettingForm: boolean = false;

  ngOnInit(): void {
    this.initializeUploader();
    this.fontsService
      .searchOptions({ angular: true, search_options: true })
      .then((success) => {
        this.paginateParams.per_page = success.per_page;
        console.log('searchOptions success', success);
        this.loadFonts();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  initializeUploader() {
    let fontId;
    this.uploader = new FileUploader({ itemAlias: 'r_file', url: this.uploadURL });
    this.uploader.onAfterAddingFile = (fileItem) => {
      console.log('onAfterAddingFile fileItem', fileItem.file);
      if (this.uploader.queue.length > 1) {
        let uploadQueue: any = this.uploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.boldUploader = new FileUploader({ itemAlias: 'b_file', url: this.uploadURL });
    this.boldUploader.onAfterAddingFile = () => {
      if (this.boldUploader.queue.length > 1) {
        let uploadQueue: any = this.boldUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.italicUploader = new FileUploader({ itemAlias: 'i_file', url: this.uploadURL  });
    this.italicUploader.onAfterAddingFile = () => {
      if (this.italicUploader.queue.length > 1) {
        let uploadQueue: any = this.italicUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.boldItalicUploader = new FileUploader({ itemAlias: 'bi_file', url: this.uploadURL  });
    this.boldItalicUploader.onAfterAddingFile = () => {
      if (this.boldItalicUploader.queue.length > 1) {
        let uploadQueue: any = this.boldItalicUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.uploader.onBuildItemForm = (item, form) => {
      form.append('name', this.fontName);
      form.append('description', this.fontDescription);
      form.append('default_font', this.isFontDefault);
    };
    this.uploader.onSuccessItem = (item: any, response: string, status: number, headers: any) => {
      this.formSubmitting = false;
      let response_json: any = JSON.parse(response);
      if (response_json.success) {
        fontId = response_json.id;
        if (fontId) {
          if (this.boldUploader.queue[0]) {
            this.formSubmitting = true;
            this.boldUploader.queue[0].method = 'PUT';
            this.boldUploader.queue[0].url = `fonts/${fontId}.json`;
            this.boldUploader.queue[0].upload();
          }
          if (this.italicUploader.queue[0]) {
            this.formSubmitting = true;
            this.italicUploader.queue[0].method = 'PUT';
            this.italicUploader.queue[0].url = `fonts/${fontId}.json`;
            this.italicUploader.queue[0].upload();
          }
          if (this.boldItalicUploader.queue[0]) {
            this.formSubmitting = true;
            this.boldItalicUploader.queue[0].method = 'PUT';
            this.boldItalicUploader.queue[0].url = `fonts/${fontId}.json`;
            this.boldItalicUploader.queue[0].upload();
          }
        }
        window.setTimeout(() => {
          console.log('setTimeout', this);
          this.notyService.notify('Font uploaded', 'success');
          this.loadFonts();
          this.reset();
        }, 5000);
      } else this.notyService.notify(response_json.text, 'error');
    };
    this.uploader.onErrorItem = (item: any, response: string, status: number, headers: any) => {
      this.notyService.notify('Error uploading font', 'error');
    };
  };

  uploadFont(formValid: boolean) {
    this.formSubmitted = true;
    if (this.uploader.queue[0] && formValid) {
      this.formSubmitting = true;
      this.uploader.queue[0].method = 'POST';
      this.uploader.queue[0].upload();
    }
  }

  loadFonts(pageEvent: any = null) {
    this.fontFormInput = '';
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.fontsService
      .index({ angular: true, page, per_page })
      .then((response_json) => {
        response_json.fonts.forEach((font: any) => {
          font.isDeleting = false;
        });
        this.fonts = response_json.fonts;
        this.fontsMaxCount = response_json.totalCount;
        console.log('indexRes', response_json);
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  deleteFont(id: string, font: any) {
    font.isDeleting = true;
    this.fontsService
      .delete({ id })
      .then((deleteResponse) => {
        console.log('deleteResponse', deleteResponse);
        this.notyService.notify('Font Deleted', 'success');
        font.isDeleting = false;
        this.loadFonts();
      })
      .catch((deleteError) => {
        console.log(deleteError);
      });
  };

  setSearchTerm(event: any) {
    this.searchTerm = event.target.value;
  };

  searchFonts(pageEvent: any = null) {
    console.log('searchTerm', this.searchTerm);
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.fontsService
      .index({ angular: true, name: this.searchTerm, page, per_page })
      .then((searchResponse) => {
        console.log('searchResponse', searchResponse);
        this.fonts = searchResponse.fonts;
        this.fontsMaxCount = searchResponse.totalCount;
      })
      .catch((searchError) => {
        console.log('searchError', searchError);
      });
  };

  getFontUploadFormInputs(event: any, inputName: string) {
    switch (inputName) {
      case 'fontName':
        this.fontName = event.target.value;
        console.log('fontName', this.fontName);
        break;
      case 'fontDescription':
        this.fontDescription = event.target.value;
        console.log('fontDescription', this.fontDescription);
        break;
    }
  };

  reset() {
    this.resettingForm = true;
    this.formSubmitted = false;
  };
}
